module.exports = __webpack_public_path__ + "media/images/pages/icn_help_s-473348bf605106b68dd24dd14d150aee.svg";